/* eslint-disable import/no-anonymous-default-export */
import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';

export const ProjectFileConfigListFilter = () => (
    <ListFilterSidebar searchPlaceholder="Search title, extension, etc." />
);
